import { Controller } from "@hotwired/stimulus"

// Modal for choosing which document a one-time Campaign is for. Selecting an
// option never navigates; only the explicit Continue button does, and it goes
// to the server-rendered URL stored on the chosen option (the campaign
// controllers still authorize the document on arrival).
export default class extends Controller {
  static targets = ["dialog", "select", "continue"]

  open() {
    this.dialogTarget.showModal()
    this.selectTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  // A click on the ::backdrop is reported with the <dialog> itself as target.
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  select() {
    this.continueTarget.disabled = !this.selectTarget.value
  }

  continue() {
    const url = this.selectTarget.selectedOptions[0]?.dataset.url
    if (url) window.location.assign(url)
  }
}
